import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../core/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import passwordHash from "js-sha512";
import { ErrorStateMatcher } from "@angular/material/core";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { MustMatch } from "./must-match.validator";
import { HttpErrorResponse } from "@angular/common/http";
import { SharedService } from "../shared/shared.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  changepasswordForm: FormGroup;
  verificationCode: string;
  passwordHide = true;
  confirmPasswordHide = true;
  errorMsg: any;
  showError: boolean = false;
  hideForm = false;
  loading: boolean = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private translationService: TranslateService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.verificationCode = params["verificationCode"];
    });
  }

  ngOnInit() {
    if (this.verificationCode != null && this.verificationCode != undefined) {
      this.verifyCode();
    } else {
      this.router.navigate(["/login"]);
    }

    let passwordregex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,15}$/;
    this.changepasswordForm = this.fb.group(
      {
        password: [
          "",
          [
            Validators.required,
            Validators.pattern(passwordregex),
            Validators.minLength(8),
            Validators.maxLength(15),
          ],
        ],
        confirmPassword: ["", [Validators.required]],
      },
      {
        validator: MustMatch("password", "confirmPassword"),
      },
    );
  }

  verifyCode() {
    this.authService.codeVerification(this.verificationCode).subscribe({
      next: (res: any) => {},
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
        if (error.status == 404) {
          this.router.navigate(["/login"]);
        }
      },
    });
  }

  changePasswordSubmit() {
    if (this.changepasswordForm.invalid) {
      return;
    }
    this.loading = true;
    this.showError = false;
    const hashedPassword = passwordHash.sha512(
      this.changepasswordForm.value.password,
    );
    this.authService.resetPassword(hashedPassword).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.translationService
          .get("Password changed successfully")
          .subscribe((text: string) => {
            this.sharedService.showMessage(text, "success");
            this.router.navigate(["/login"], { queryParams: {} });
          });
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        // this.showError = true;
        this.handleError(error);
        this.errorMsg = error.error.errors.messages[0];
      },
    });
  }
  handleError(error) {
    this.sharedService.handleError(error);
  }
}
